'use client';

import { c as _c } from "react/compiler-runtime";
import { Monitor, Moon, Sun } from 'lucide-react';
import useDarkMode, { type ThemeSetting } from '../../hooks/useDarkMode';
const themeOptions: {
  value: ThemeSetting;
  label: string;
  description: string;
  icon: React.ReactNode;
}[] = [{
  value: 'light',
  label: 'Light',
  description: 'A clean, bright appearance',
  icon: <Sun width={24} height={24} />
}, {
  value: 'dark',
  label: 'Dark',
  description: 'Easy on the eyes',
  icon: <Moon width={24} height={24} />
}, {
  value: 'system',
  label: 'System',
  description: 'Matches your device settings',
  icon: <Monitor width={24} height={24} />
}];
const Theme = () => {
  const $ = _c(7);
  const {
    themeSetting,
    setTheme
  } = useDarkMode();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-lg font-semibold">Appearance</p>;
    t1 = <span className="mt-1 block text-sm text-textSecondary">Choose your preferred theme</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setTheme || $[3] !== themeSetting) {
    t2 = themeOptions.map(option => <button key={option.value} onClick={() => setTheme(option.value)} className={`flex flex-col items-center gap-2 rounded-lg border-2 p-4 transition-all ${themeSetting === option.value ? "border-primary bg-primary/10" : "border-ds-border-standard hover:border-textSecondary"}`}><div className={themeSetting === option.value ? "text-primary" : "text-textPrimary"}>{option.icon}</div><span className={`text-sm font-semibold ${themeSetting === option.value ? "text-primary" : "text-textPrimary"}`}>{option.label}</span><span className="text-center text-xs text-textSecondary">{option.description}</span></button>);
    $[2] = setTheme;
    $[3] = themeSetting;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="flex flex-col items-center space-y-4 p-4"><div className="mt-4 w-full max-w-[660px]">{t0}{t1}<div className="mt-4 grid grid-cols-3 gap-3">{t2}</div></div></div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default Theme;